<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import Title from '@/mixin/title'

export default {
  name: 'App',
  mixins: [ Title ],
  computed: {
  },
  updated() {
  },
  watch: {
    $route (to, from){
      $(document).trigger('hideMenu')
    }
  },
  mounted() {
    //===== Menu Active =====//
    var cururl = window.location.pathname
    var curpage = cururl.substr(cururl.lastIndexOf('/') + 1)
    var hash = window.location.hash.substr(1)
    if ((curpage == '' || curpage == '/' || curpage == 'admin') && hash == '') {
      //$("nav .navbar-nav > li:first-child").addClass("active");
    } else {
      $('.header__menu-list li').each(function () {
        $(this).removeClass('active')
      })
      if (hash != '')
        $(".header__menu-list li a[href*='" + hash + "']")
            .parents('li')
            .addClass('active')
      else
        $(".header__menu-list li a[href*='" + curpage + "']")
            .parents('li')
            .addClass('active')
    }

    $(document).on('showMenu', function () {
      $('.header__menu-button').addClass('animate')
      $('body').addClass('overflow-hidden')
      $('.header__menu-list').addClass('show')
      $('.list__item-logo').addClass('show')
      $('.header__overlay').addClass('overlay')
      $('.submenu').removeClass('show')
      $('.has-child').removeClass('color')
    })
    $(document).on('hideMenu', function () {
      $('.header__menu-button').removeClass('animate')
      $('body').removeClass('overflow-hidden')
      $('.header__menu-list').removeClass('show')
      $('.list__item-logo').removeClass('show')
      $('.header__overlay').removeClass('overlay')
      $('.submenu').removeClass('show')
      $('.has-child').removeClass('color')
    })

    $(document).on('click', '.header__menu-button, .header__overlay', function () {
      if ($('.overflow-hidden').length) {
        $(document).trigger('hideMenu')
      }
      else {
        $(document).trigger('showMenu')
      }

    })
    $(document).on('click', '.router-link-active', function () {
      $('.header__menu-button').removeClass('animate')
      $('body').removeClass('overflow-hidden')
      $('.header__menu-list').removeClass('show')
      $('.header__overlay').removeClass('overlay')
    })
    $(document).on('click', '.has-child', function () {
      $(this).toggleClass('active')
      $(this).next('.submenu').toggleClass('show')
    })
    $(document).on('click', '.buttonTeam', function() {
      $('body').addClass('overflow-hidden')
    })
    $(document).on('click', '.card__overlay', function() {
      $('body').removeClass('overflow-hidden')
      $(this).removeClass('show')
      $('.card__info').removeClass('show')
    })
    $(document).on('click', '.buttonClose', function() {
      $('body').removeClass('overflow-hidden')
    })
  }
}
</script>
